module.exports = __webpack_public_path__ + "img/schnittkante_grau_candy.40e32731.jpg";